import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Instagram, Facebook, Linkedin } from "lucide-react";
import { apiClient } from "@/lib/api";
import logo from "@/assets/logo.png";

const SOCIAL_LINKS = [
  { key: "instagram_url", label: "Instagram", Icon: Instagram },
  { key: "facebook_url", label: "Facebook", Icon: Facebook },
  { key: "linkedin_url", label: "LinkedIn", Icon: Linkedin },
];

export const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    apiClient
      .get("/settings")
      .then(({ data }) => setSettings(data))
      .catch(() => setSettings({}));
  }, []);

  const activeSocials = settings ? SOCIAL_LINKS.filter((s) => settings[s.key]) : [];

  return (
    <footer className="bg-deep border-t border-gold/10 py-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Ferguson's logo" className="h-12 w-auto logo-glow" />
          <div className="text-sm text-[#A1B0A6]">
            <div className="font-display font-semibold text-[#F4F7F5]">FERGUSON'S</div>
            <div className="text-xs">Customs Broker &amp; Freight Forwarders Ltd</div>
          </div>
        </div>

        {activeSocials.length > 0 && (
          <div className="flex items-center gap-3" data-testid="footer-social-links">
            {activeSocials.map(({ key, label, Icon }) => (
              <a
                key={key}
                href={settings[key]}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="flex items-center justify-center h-9 w-9 rounded-full border border-gold/20 text-[#A1B0A6] hover:text-gold hover:border-gold/50 transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        )}

        <p className="text-xs text-[#6E7E74] text-center">
          &copy; {new Date().getFullYear()} Ferguson's Customs Broker &amp; Freight Forwarders Ltd. All rights reserved.
        </p>
        <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-[#6E7E74] hover:text-gold transition-colors">
          Admin Portal
        </Link>
      </div>
    </footer>
  );
};
